<template>
    <loading v-if="fetching"></loading>

    <div v-else-if="hasData">

        <application-title :title="$t('applications.questionnaire.title')" />

        <div v-if="hasOverallScore" class="mb-16">
            <tag
                display="secondary"
                icon="star"
            >
                {{ $t('applications.questionnaire.overall_score') }}: {{ overallScore }}%
            </tag>
        </div>

        <div v-for="q in questions" class="mb-20">
            <p class="font-semibold mb-8">
                {{ q.question }}
                <tag
                    v-show="hasScore(q)"
                    display="secondary"
                    icon="star"
                >
                    {{ q.score }}%
                </tag>
            </p>
            <div v-for="a in q.answers" class="mb-8">
                <span class="flex flex-row items-center">
                    <tooltip v-if="a.preferred" :content="$t('applications.questionnaire.preferred_answer')" position="bottom">
                        <svg-icon type="star" />
                    </tooltip>
                    {{ a.answer }}
                </span>
            </div>
        </div>

        <div v-for="p in privacy">
            <p class="font-semibold mb-8">{{ p.question }}</p>
            <p>{{ $t('applications.questionnaire.consent_given') }}: <span class="capitalize">{{ p.consent ? $t('general.yes') : $t('general.no') }}</span></p>
        </div>

    </div>
</template>

<script>
import {normalizeJson} from '../../shared/helpers';
import {getSeekQuestionnaire} from '../services/SeekQuestionnaireService';
import Loading from './ui/Loading.vue';
import Tooltip from "./navigation/Tooltip.vue";
import Application from '../models/Application';
import SeekQuestionnaire from '../models/SeekQuestionnaire';
import Tag from "./ui/Tag.vue";
import ApplicationTitle from "./applications/ApplicationTitle.vue";
import {useRepo} from 'pinia-orm';

export default {
    components: {
        ApplicationTitle,
        Tag,
        'loading': Loading,
        'tooltip': Tooltip,
    },
    props: {
        application: {
            type: Application,
            required: true,
        },
    },
    data: function() {
        return {
            fetching: false,
            questionnaire: null,
        }
    },
    computed: {
        overallScore() {
            return this.questionnaire.overall_score;
        },
        questions() {
            return this.questionnaire.questions;
        },
        privacy() {
            return this.questionnaire.privacy;
        },
        hasData() {
            return this.questionnaire !== null;
        },
        hasOverallScore() {
            return this.questionnaire.overall_score !== null;
        }
    },
    methods: {
        load() {
            if (this.questionnaire) return;
            this.questionnaire = useRepo(SeekQuestionnaire)
                                    .where('application_id', this.application.id)
                                    .first();
        },
        fetch() {
            this.fetching = true;
            getSeekQuestionnaire(this.application.id)
                .then(result => {
                    if (!result) return;
                    return useRepo(SeekQuestionnaire).save(normalizeJson(result));
                })
                .then(inserts => {
                    this.load();
                    this.fetching = false;
                });
        },
        hasScore(q) {
            return q.score !== null;
        }
    },
    mounted() {
        this.fetch();
    },
};
</script>
